import styled from '@emotion/styled';

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  flex: 3;
  height: 100%;
`;
